import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { TableBody, TableRow } from '@material-ui/core';

import { TableRowsProps } from './interfaces';
import { TableRowsCell } from './TableRowsCell';

export const TableRows = <T, K extends keyof T>({ data, columns }: TableRowsProps<T, K>) => {
  return (
    <TableBody>
      {data.map((row) => (
        <TableRow key={uuidv4()} style={row.highlight ? { backgroundColor: row.highlightColor } : {}}>
          {columns.map((column) => (
            <TableRowsCell key={uuidv4()} column={column} row={row} strike={row.strike} />
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};
